import { get, set, cloneDeep } from 'lodash';

import { actionTypes as taxesActionTypes } from '../taxes/actions';

import { actionTypes } from './actions';
import initialState from './initialState';

export default function taxesPaymentReducer(state = initialState, action) {
  switch (action.type) {
    case taxesActionTypes.REQUEST_START:
      return {
        ...state,
        ...{
          editMode: false,
          loading: true,
          error: null,
          data: null,
        },
      };

    case taxesActionTypes.REQUEST_FAILURE:
      return {
        ...state,
        ...{
          editMode: false,
          loading: false,
          data: null,
          error: action.payload,
        },
      };

    case actionTypes.SET_DATA:
      return { ...state, data: action.payload };

    case actionTypes.EDIT:
      return handleEdit(state, action.payload);

    case actionTypes.REVERT:
      return handleRevert(state, action.payload);

    case actionTypes.SET_DISABLED:
      return handleSetDisabled(state, action.payload);

    default:
      return state;
  }
}

function handleRevert(state, path) {
  const nextState = cloneDeep(state);
  const initialValue = get(state, ['data', 'toPayBak', ...path, 'value']);
  set(nextState, ['data', 'toPay', ...path, 'value'], initialValue);
  return state.setIn(['data', 'toPay', ...path, 'value'], initialValue);
}

function handleEdit(state, { path, value }) {
  const nextState = cloneDeep(state);
  set(nextState, ['data', 'toPay', ...path, 'value'], value);
  return nextState;
}

function handleSetDisabled(state, { path, value }) {
  const nextState = cloneDeep(state);
  set(nextState, ['data', 'toPay', ...path, 'disabled'], value);
  return { ...state, ...nextState };
}
